import { ComponentProps, FC } from 'react';
import { AutocompleteElement, useFormContext } from 'react-hook-form-mui';
import { useTranslation } from 'next-i18next';
import capitalize from 'lodash.capitalize';

interface Props
  extends Omit<ComponentProps<typeof AutocompleteElement>, 'options'> {
  disabled?: boolean;
}

export const CompanyTypeAutocomplete: FC<Props> = (props) => {
  const { autocompleteProps, ...rest } = props;
  const { t } = useTranslation(['common']);
  const { setValue } = useFormContext();
  const types = ['manufacturer', 'importer'];

  const options = types.map((key) => ({
    id: key,
    label: t(`common:${capitalize(key)}`),
  }));

  return (
    <AutocompleteElement
      options={options}
      autocompleteProps={{
        disabled: props.disabled,
        onChange: (event, value) => {
          setValue(props.name, value?.id);
        },
        getOptionLabel: (option) => {
          if (option?.id) {
            return options.find((o) => o.id === option.id)?.label;
          }
          return options.find((o) => o.id === option)?.label;
        },
        ...autocompleteProps,
      }}
      {...rest}
    />
  );
};
